import { useState, useEffect } from "react";
import { LeadMagnetApi } from "../../service";
import Logo from "../assets/Logo.png";
import "./LeadMagnet.css";

export default function LeadMagnetDownload() {
  const [ebookUrl, setEbookUrl] = useState(null);
  const [ebookFilename, setEbookFilename] = useState("PropertEasy_Guide.pdf");
  const [bookMockupUrl, setBookMockupUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  // Prevent search engine indexing
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex,nofollow";
    document.head.appendChild(meta);
    return () => document.head.removeChild(meta);
  }, []);

  useEffect(() => {
    // Fetch the eBook download URL
    LeadMagnetApi.getEbookUrl()
      .then((data) => {
        setEbookUrl(data.ebookUrl || null);
        setEbookFilename(data.ebookFilename || "PropertEasy_Guide.pdf");
      })
      .catch(() => {})
      .finally(() => setLoading(false));

    // Fetch the book mockup image from the page content
    LeadMagnetApi.getPage()
      .then((data) => setBookMockupUrl(data.bookMockupImageUrl || null))
      .catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex flex-col font-sans bg-gray-50">
      {/* ── Minimal Header ── */}
      <header className="bg-white border-b border-gray-100 px-6 py-4">
        <img src={Logo} alt="PropertEasy" className="h-8 w-auto" />
      </header>

      {/* ── Download Content ── */}
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-lg w-full bg-white rounded-2xl shadow-lg p-10 text-center">
          <h1
            className="text-[28px] md:text-[36px] font-bold text-gray-900 mb-2 uppercase"
            style={{ fontFamily: "'Oswald', sans-serif", lineHeight: 1.0, letterSpacing: "0.03em" }}
          >
            Your Free Guide
          </h1>
          <p className="text-gray-500 mb-8" style={{ fontSize: "15px", lineHeight: 1.65, fontFamily: "'Inter', sans-serif" }}>
            10 Hidden Dangers in Your Home — A Long Island Property Owner's Guide
          </p>

          {/* Book mockup image */}
          {bookMockupUrl && (
            <img
              src={bookMockupUrl}
              alt="10 Hidden Dangers in Your Home eBook"
              className="max-w-[220px] mx-auto mb-8 drop-shadow-xl"
            />
          )}

          {loading ? (
            <div className="flex justify-center py-4">
              <div
                className="w-8 h-8 border-4 border-t-transparent rounded-full animate-spin"
                style={{ borderColor: "#4DB05A", borderTopColor: "transparent" }}
              />
            </div>
          ) : ebookUrl ? (
            <>
              <a
                href={ebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                download={ebookFilename}
                className="block w-full text-white font-semibold py-4 rounded-lg uppercase tracking-wider transition-opacity"
                style={{ backgroundColor: "#4DB05A", fontSize: "14px", fontFamily: "'Inter', sans-serif" }}
              >
                Download Now
              </a>
              <p className="text-xs text-gray-400 mt-3">
                {ebookFilename} — PDF
              </p>
            </>
          ) : (
            <p className="text-gray-400 text-sm">
              The download link will be available shortly. Check your email — we sent it there too!
            </p>
          )}
        </div>
      </main>

      {/* ── Footer ── */}
      <footer className="bg-white border-t border-gray-100 py-6 px-6">
        <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <img src={Logo} alt="PropertEasy" className="h-7 w-auto" />
          <p className="text-gray-400 text-xs">
            &copy;{new Date().getFullYear()} PropertEasy. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
